import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { signInsurance as signInsuranceAction } from '../store/actions/customer-actions';

export default function useInsurance(loan) {
  const dispatch = useDispatch();

  const signInsurance = useCallback((loanId, device) => dispatch(signInsuranceAction(device)), [dispatch]);

  const isLoanInsured = useCallback(() => loan.application?.financial?.insured, [loan]);

  /**
   * Calculate value per day and sum the parameter if exists
   */
  const calculateDailyAmount = useCallback(
    (amountToSum = 0) => {
      const monthlyPremiumWithTaxes = loan?.conditions?.insurance?.monthlyPremiumWithTaxes;

      if (monthlyPremiumWithTaxes) {
        const amountForDay = monthlyPremiumWithTaxes / 30; // reais for day
        return (amountForDay + amountToSum).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      }
    },
    [loan],
  );

  const getMonthlyAmount = useCallback(() => {
    const monthlyPremiumWithTaxes = loan?.conditions?.insurance?.monthlyPremiumWithTaxes;

    if (monthlyPremiumWithTaxes) {
      return monthlyPremiumWithTaxes.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
  }, [loan]);

  return {
    isLoanInsured,
    signInsurance,
    calculateDailyAmount,
    getMonthlyAmount,
  };
}
